import React, { Component } from 'react'
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl'
import InputMask from 'react-input-mask'
import createAxios from 'utils/axios'

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from '../../dashboard/constants'

class Login extends Component {
  constructor(props) {
    super(props)

    let impersonateType = 'username'

    if (props.customer) {
      impersonateType = 'username'
    } else if (props.iccid) {
      impersonateType = 'iccid'
    } else if (props.imsi) {
      impersonateType = 'imsi'
    }

    this.state = {
      iccid: props.iccid,
      imsi: props.imsi,
      login: props.login,
      email: props.customer,
      phone: '86 ',
      mask: '99 999 9999 9999',
      password: '',
      message: '',
      fetching: false,
      disableBtn: false,
      impersonateType,
    }

    this.onChange = this.onChange.bind(this)
    this.focusHandler = this.focusHandler.bind(this)
    this.radioChange = this.radioChange.bind(this)
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  onChange(e) {
    this.setState({ [e.target.id]: e.target.value })
  }

  changePhone(e) {
    let phone = e.target.value
    let mask = '99 999 9999 9999'

    if (phone.slice(0, 3) !== '86 ') {
      mask = ''
      phone = phone.replace(/_/g, '').replace(/\s/g, '')
    }

    this.setState({
      phone,
      mask
    })
  }

  focusHandler() {
    this.setState({ message: '', disableBtn: false })
  }

  radioChange(e) {
    this.setState({ impersonateType: e.target.value })
  }

  submitHandler(e) {
    e.preventDefault()

    this.setState({
      fetching: true,
      message: ''
    }, this.validate)
  }

  request() {
    const { email, phone, password, login, iccid, imsi, impersonateType } = this.state
    const { activationCode } = this.props
    const cleanedPhone = phone.replace(/_/g, '').replace(/\s/g, '')

    const url = '/impersonate'
    const payload = {
      login: login,
      password: password,
    }

    if (impersonateType === 'username') {
      if (email) {
        payload.username = email
      } else if (cleanedPhone !== '86') {
        payload.username = cleanedPhone
      }
    } else if (impersonateType === 'iccid') {
      payload.iccid = iccid
    } else if (impersonateType === 'imsi') {
      payload.imsi = imsi
    }

    this.axios.post(url, payload).then(({ data: { error } }) => {
      this.setState({ fetching: false })

      if (error) {
        this.setState({ disableBtn: false, message: error })
      } else {
        window.location = this.link('/dashboard')
      }
    })
  }

  validate(e) {
    this.setState({ fetching: true })
    const { email, phone, password, iccid, imsi, login } = this.state
    const { region } = this.props
    let valid = true
    let username = ''

    if (region === CHINA_REGION && (!this.validatePresence(phone) && phone !== '86 ')) {
      username = phone
    } else if (region === 'global' && (!this.validatePresence(email))) {
      username = email
    }

    valid = [iccid, imsi, username].some(el => !this.validatePresence(el))

    if (this.validatePresence(password)) {
      valid = false
    }

    if (this.validatePresence(login)) {
      valid = false
    }

    if (!valid) {
      this.setState({
        fetching: false,
        message: this.t('ActivationCode.FieldsAreRequired')
      })
    } else {
      this.setState({ disableBtn: true })
      this.request()
    }
  }

  validatePresence (value) {
    const re = /^\s+$/

    if (value.length === 0 || re.test(value)) {
      return true
    }
  }

  renderUsernameField() {
    const { phone, email, mask } = this.state

    if (this.props.region === CHINA_REGION) {
      return (
        <div className="form-group form-group-icon">
          <InputMask
            type="text"
            id="phone"
            name="username"
            value={phone}
            onChange={this.changePhone.bind(this)}
            onFocus={this.focusHandler}
            placeholder='username'
            mask={mask}
            maskChar="_"
          />
          <i className="form-icon form-icon-phone"></i>
        </div>
      )
    }

    return (
      <div className="form-group form-group-icon">
        <input
          type="text"
          id="email"
          name="username"
          value={email}
          onChange={this.onChange}
          onFocus={this.focusHandler}
          placeholder='username'
        />
        <i className="form-icon form-icon-mail"></i>
      </div>
    )
  }

  render() {
    const { locale, loginPath, region } = this.props
    const {
      password, message, fetching,
      iccid, imsi, login, impersonateType,
    } = this.state

    return (
      <div className="login">
        <h3>Service Login</h3>

        <form
          onSubmit={this.submitHandler.bind(this)}
          method="POST" className="form"
        >
          <div className="form-group form-group-icon">
            <input
              type="text"
              id="login"
              name="login"
              value={login}
              onChange={this.onChange}
              onFocus={this.focusHandler}
              placeholder="Login"
            />
            <i className="form-icon form-icon-mail"></i>
          </div>

          <div className="form-group form-group-icon">
            <input
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={this.onChange}
              onFocus={this.focusHandler}
              placeholder={this.t('Common.Password')}
            />
            <i className="form-icon form-icon-password"></i>
          </div>

          <div>
            <input
              type="checkbox"
              value="username"
              checked={impersonateType === 'username'}
              tabIndex={-1}
              onChange={this.radioChange}
            /> username
            <input
              type="checkbox"
              value="iccid"
              checked={impersonateType === 'iccid'}
              tabIndex={-1}
              onChange={this.radioChange}
            /> ICCID
            <input
              type="checkbox"
              value="imsi"
              checked={impersonateType === 'imsi'}
              tabIndex={-1}
              onChange={this.radioChange}
            /> IMSI
          </div>
          <br />

          {impersonateType === 'username' && this.renderUsernameField()}

          {impersonateType === 'iccid' &&
            <div className="form-group form-group-icon">
              <input
                type="text"
                id="iccid"
                name="iccid"
                value={iccid}
                onChange={this.onChange}
                onFocus={this.focusHandler}
                placeholder="ICCID"
              />
              <i className="form-icon form-icon-mail"></i>
            </div>
          }

          {impersonateType === 'imsi' &&
            <div className="form-group form-group-icon">
              <input
                type="text"
                id="imsi"
                name="imsi"
                value={imsi}
                onChange={this.onChange}
                onFocus={this.focusHandler}
                placeholder="IMSI"
              />
              <i className="form-icon form-icon-mail"></i>
            </div>
          }

          <div className="form__message">
            <small className="error">{ message.length > 0 && message }</small>
            { fetching &&
              <div className="wrapper">
                <div className="cssload-loader"></div>
              </div>
            }
          </div>

          <input
            type="submit"
            disabled={this.state.disableBtn}
            className="button button-dark-blue"
            value={this.t('Login.Login')}
          />

        </form>

      </div>
    )
  }
}

export default injectIntl(Login)



// WEBPACK FOOTER //
// ./app/javascript/components/application/impersonate/app.js